<template>
	<vx-card class="p-2" style="width: 290px; height: 380px">
		<div class="vx-row mb-3">
			<div class="vx-col">
				<h3>Contrat N° {{ contractInfo.id ? contractInfo.id : " " }}</h3>
			</div>
		</div>
		<div class="vx-row mb-3">
			<div class="vx-col">
				<h3>
					Prestation :
					{{
						contractInfo.delivery
							? allProductsCategories[contractInfo.delivery - 1]
							: " "
					}}
				</h3>
			</div>
		</div>
		<div class="vx-row mb-3">
			<div class="vx-col">
				<vs-chip
					style="width: 80px"
					:color="getContractStatusColor(parseInt(contractInfo.status))"
					>{{ getContractStatus(parseInt(contractInfo.status)) }}</vs-chip
				>
			</div>
		</div>
		<!-- AVATAR -->
		<div class="vx-row mb-3">
			<div class="vx-col">
				<h3 class="pt-3">Consultant(e-s) :</h3>
			</div>
			<div
				class="vx-col mr-2"
				v-for="(collaborator, indexCollab) in collaborators"
				:key="indexCollab"
			>
				<div class="vx-row">
					<vx-tooltip
						:text="collaborator.firstname + ' ' + collaborator.lastname"
					>
						<vs-avatar
							style="border: 1px solid"
							class="mx-auto mb-6 block"
							size="30px"
							:src="getCollaboratorAvatar(collaborator.user_id)"
							@click="showCollaboratorCard(collaborator)"
						/>
					</vx-tooltip>
				</div>
			</div>
		</div>
		<div
			v-if="contractInfo.delivery && contractInfo.delivery == 0"
			style="position: absolute; top: 240px; left: 70px; height: 80px"
		>
			<div class="vx-row mt-2">
				<vs-button
					class="shadow-lg"
					icon-pack="material-icons"
					icon="description"
					color="primary"
					style="width: 180px"
					@click="toDocuments(contractInfo.society_id)"
					>Vers Documents</vs-button
				>
			</div>
			<div class="vx-row mt-2">
				<vs-button
					class="shadow-lg"
					icon-pack="material-icons"
					icon="trending_up"
					color="primary"
					style="width: 180px"
					@click="toKeywords(contractInfo.society_id)"
					>Vers Keywords</vs-button
				>
			</div>
			<div class="vx-row mt-2">
				<vs-button
					class="shadow-lg"
					icon-pack="material-icons"
					icon="share"
					color="primary"
					style="width: 180px"
					@click="toNetlink(contractInfo.society_id)"
					>Vers Netlinking</vs-button
				>
			</div>
		</div>
	</vx-card>
</template>

<script>
import store from "@/store/store";
import fieldConvertorMixin from "@/mixins/dbFieldConvertorMixin";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	components: { VxTooltip },
	name: "ContractCard",

	mixins: [fieldConvertorMixin],
	props: {
		contractInfo: {
			type: Object,
			default: null,
		},
		collaborators: {
			type: Array,
			default: null,
		},
	},
	computed: {
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allProductsCategories: () => {
			return store.state.products_categories.map((row) => row.name);
		},
	},
	data() {
		return {};
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	created() {
		this.getAllCollaboratorsAvatar();
		this.getAllProductsCategories();
	},
	methods: {
		toKeywords(societyId) {
			this.$emit("to-keywords", societyId);
		},
		toNetlink(societyId) {
			this.$emit("to-netlink", societyId);
		},
		toDocuments(societyId) {
			this.$emit("to-documents", societyId);
		},
		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},
		getAllProductsCategories() {
			this.$store.dispatch("getAllProductsCategories");
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar ? foundAvatar.avatar : "";
			else return "";
		},
		showCollaboratorCard(collaborator) {
			this.$emit("show-collaborator-card", collaborator);
		},
	},
};
</script>
